<template>
  <div class="image-card">
    <div class="vogue-image-card">
      <a class="vogue-card" :href="toLink()" @click="moduleLink()">
        <div
          class="collections-image"
          :class="[type == 'grid' && count == '1' ? 'image-auto' : `image-${image_style}`]"
        >
          <v-lazy-img  class="d-md-block d-none" v-if="list.image || list.mobile_image" :data-url="(list.image&&list.image.url) || (list.mobile_image&&list.mobile_image.url)" :src="(list.image && list.image.thumbnail) ||  (list.mobile_image&&list.mobile_image.thumbnail)"></v-lazy-img>
          <v-lazy-img  class="d-block d-md-none" v-if="list.image || list.mobile_image" :data-url="(list.mobile_image&&list.mobile_image.url) || (list.image&&list.image.url) " :src="(list.mobile_image && list.mobile_image.thumbnail) ||  (list.image&&list.image.thumbnail)"></v-lazy-img>
        </div>
        <div
          class="text d-md-block d-none"
          :type="type"
          :count="count"
          :class="[
            `text-${text_align}`,
            `text-Y-${text_position}`,
            `text-X-${text_align}`,
            show_mb_text == 'no' ? 'd-block' : '',
            type == 'grid' && count == '1' ? 'image-46-22-18' : '',
            type == 'grid' && count == '2' ? 'image-30-24-20' : '',
            type == 'grid' && count == '3' ? 'image-26-20-14' : '',
            type == 'grid' && count == '4' ? 'image-20-14-14' : '',
            type == 'grid' && count == '5' ? 'image-16-12-12' : '',
            type == 'grid' && count == '1' ? 'text-Y-center' : '',
            type == 'six_blend' && wildscreen ? 'image-26-20-14' : '',
            type == 'six_blend' && !wildscreen ? 'image-20-14-14' : '',
            type == 'blend' && status == 'main' && wildscreen ? 'image-40-34-26' : '',
            type == 'blend' && status == 'main' && !wildscreen ? 'image-30-24-20' : '',
            type == 'blend' && status == 'secondary' && wildscreen ? 'image-30-24-20' : '',
            type == 'blend' && status == 'secondary' && !wildscreen ? 'image-26-20-14' : '',
            type == 'blend' && status == 'main' && wildscreen ? '' : '',
            type == 'grid' && status == 'main' ? 'image-14-11-12' : '',
            type == 'grid' && status == 'secondary' ? 'image-13-10-11' : '',
          ]"
          :style="[{ color: list.text_color }]"
        >
          <h5 :style="{ color: button_color && button_color.text_color }" v-if="list.title" class="title_font">
            {{ list.title }}
          </h5>
          <p
            class="page_text_font"
            v-if="list.description"
            :style="{ 'transform-origin': text_align, color: button_color && button_color.text_color }"
          >
            {{ list.description }}
          </p>
          <a
            v-if="customBtnHref"
            class="button_class title_font"
            :limit_mobile="limit_mobile"
            :class="{'link_button_zoom':limit_pc||limit_mobile,'only_button':!list.image&&!list.mobile_image}"
            :style="{
              '--button-limit-pc':limit_pc,
              '--button-limit-mobile':limit_mobile,
              'transform-origin': text_align,
              color: button_color && button_color.obutton_text_color,
              'background-color': button_color && button_color.bg_color,
            }"
            :href="customBtnHref"
            @click="moduleLink()"
            >{{ list.button.text }}</a
          >
        </div>
        <div class="mask" v-if="mask_opacity" :style="{ opacity: mask_opacity }"></div>
      </a>
    </div>

    <div
      v-if="(list.button && list.button.text && list.button.url) || list.title || list.description"
      class="text d-md-none d-none"
      :class="[
        `text-${text_align}`,
        {
          'image-14-11-12': status == 'main',
          'image-13-10-11': status == 'secondary',
          'd-block': show_mb_text == 'yes',
        },
      ]"
    >
      <h5 v-if="list.title" :style="{ color: button_color && button_color.text_color }" class="title_font">
        {{ list.title }}
      </h5>
      <p
        class="page_text_font"
        v-if="list.description"
        :style="{ 'transform-origin': text_align, color: button_color && button_color.text_color }"
      >
        {{ list.description }}
      </p>
      <a
        v-if="customBtnHref"
        class="button_class title_font"
        :class="{'link_button_zoom':limit_pc||limit_mobile}"
        :style="{
          '--button-limit-mobile':limit_mobile,
          'transform-origin': text_align,
          color: button_color && button_color.obutton_text_color,
          'background-color': button_color && button_color.bg_color,
        }"
        :href="customBtnHref"
        @click="moduleLink()"
        >{{ list.button.text }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'list',
    'image_style',
    'mask_opacity',
    'text_align',
    'type',
    'count',
    'wildscreen',
    'status',
    'text_position',
    'show_mb_text',
    'button_color',
    'limit_pc',
    'limit_mobile',
  ],
  methods: {
    toLink() {
      if(this?.list?.type == 'point' || this?.list?.button?.type == 'point') {
        return 'javascript:;'
      }
      return this?.list?.url || this?.list?.button?.url;
    },
    moduleLink() {
      if(this.list?.button?.type == 'point' && this.list?.button?.point_target) {
        moduleScroll(this.list.button.point_target);
      }
      else if (this.list?.type == 'point' && this.list?.point_target) {
        moduleScroll(this.list.point_target);
      }
    }
  },
  computed: {
    customBtnHref() {
      if(this?.list?.button?.text) {
        if(this.list.button?.type == 'point' && this.list.button?.point_target) {
           return 'javascript:;'
        }
        return this.list.button?.type == 'link' && this.list.button.url || !this.list.button?.type && this.list.button.url;
      }
      return false;
    },
  }
};
</script>

<style lang="scss" scoped>
.image-card {
  position: relative;
  min-height: 48px;
  .text {
    width: 100%;
    max-width: 80%;
    padding: 20px;
    color: #000;
    font-size: 16px;
    h5 {
      font-size: 24px;
      margin-bottom: 0;
      font-weight: bold;
    }

    a {
      display: inline-block;
      color: #fff;
      background: #000;
    }
  }
  .vogue-card {
    // position: relative;
    // .image {
    //   width: 100%;
    //   height: 100%;
    //   transition: transform 8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    //   img {
    //     width: 100%;
    //     height: 100%;
    //   }
    // }
    & > .text {
      position: absolute;
      bottom: 0;
    }
    // &:hover {
    //   .image {
    //      transform: scale(1.2);
    //   }
    // }
  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 5;
  }
}
.image-46-22-18 {
  padding: 30px !important;
  h5 {
    font-size: 46px !important;
  }
  p {
    font-size: 22px !important;
    margin-top: 13px !important;
  }
  a {
    font-size: 18px !important;
    padding: 15px 30px !important;
    margin-top: 30px !important;
  }
}
.image-40-34-26 {
  padding: 30px !important;
  h5 {
    font-size: 40px !important;
  }
  p {
    font-size: 34px !important;
    margin-top: 13px !important;
  }
  a {
    font-size: 26px !important;
    padding: 15px 30px !important;
    margin-top: 30px !important;
  }
}
.image-30-24-20 {
  padding: 30px !important;
  h5 {
    font-size: 30px !important;
  }
  p {
    font-size: 24px !important;
    margin-top: 13px !important;
  }
  a {
    font-size: 20px !important;
    padding: 12px 24px !important;
    margin-top: 30px !important;
  }
}
.image-26-20-14 {
  padding: 15px !important;
  h5 {
    font-size: 26px !important;
  }
  p {
    font-size: 20px !important;
    margin-top: 13px !important;
  }
  a {
    font-size: 14px !important;
    padding: 10px 20px !important;
    margin-top: 30px !important;
  }
}
.image-20-14-14 {
  padding: 15px !important;
  h5 {
    font-size: 20px !important;
  }
  p {
    font-size: 14px !important;

    margin-top: 13px !important;
  }
  a {
    font-size: 14px !important;
    padding: 7px 14px !important;
    margin-top: 24px !important;
  }
}
.image-16-12-12 {
  padding: 15px !important;
  h5 {
    font-size: 16px !important;
  }
  p {
    font-size: 12px !important;
    margin-top: 13px !important;
  }
  a {
    font-size: 12px !important;
    padding: 5px 9px !important;
    margin-top: 24px !important;
  }
}
.image-14-11-12 {
  padding: 15px !important;
  h5 {
    font-size: 14px !important;
  }
  p {
    font-size: 11px !important;
    transform: scale(0.92);
    margin-top: 7px !important;
  }
  a {
    font-size: 12px !important;
    padding: 6px 11px !important;
    margin-top: 15px !important;
  }
}
.image-13-10-11 {
  padding: 15px !important;
  h5 {
    font-size: 13px !important;
  }
  p {
    font-size: 10px !important;

    transform: scale(0.83);
    margin-top: 6px !important;
  }
  a {
    font-size: 11px !important;
    transform: scale(0.92);
    padding: 5px 8px !important;
    margin-top: 15px !important;
  }
}
.text-X-center {
  left: 50%;
  transform: translateX(-50%);
}
.text-X-left {
  left: 0;
}
.text-X-right {
  right: 0;
}
.text_Y_buttom {
  top: unset !important;
  bottom: 0 !important;
  transform: unset !important;
}
.text_Y_center {
  top: 50% !important;
  transform: translateY(-50%) !important;
  bottom: unset !important;
}
.image-fixed {
  padding-top: 100%;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    backface-visibility: hidden;
  }
}
.image-auto {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
// @media (max-width: 767px) {
//   .image-card {
//     .text > a {
//       padding-top: 15px !important;
//       padding-bottom: 15px !important;
//     }
//   }
// }
</style>